import { LikesParams } from "../entities/getLikesParams";
import { LikesYouResponse } from "../entities/likesYou";
import { MatchRepository } from "../repositories/MatchRepository";

export class GetLikes {
	constructor(private repository: MatchRepository) {}
	execute(params: GetLikesParams): Promise<LikesYouResponse> {
		return this.repository.getLikes(params.params);
	}
}

export class GetLikesParams {
	constructor(public params: LikesParams) {}
}
